import { render, staticRenderFns } from "./CardPhotoJourneyImage.vue?vue&type=template&id=4d51f660&scoped=true"
import script from "./CardPhotoJourneyImage.vue?vue&type=script&lang=js"
export * from "./CardPhotoJourneyImage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d51f660",
  null
  
)

export default component.exports